import React from 'react';
import Navbar from '../../components/navbar/Navbar';
import { Box } from '@mui/material';
import SponsorPage from '../../components/sponsor_page/SponsorPage';
import Footer from '../../components/Footer/Footer';

const SponsorPage1 = () => {
	return (
		<Box>
			<Navbar />
			<SponsorPage />
			<Footer />
		</Box>
	);
};

export default SponsorPage1;
